import type { ReactNode } from 'react'

import {
  ErrorFallback,
  type ErrorFallbackProps,
} from '../../feedback/errorFallback/ErrorFallback'
import { Card } from './Card'
import { CardHeader } from './CardHeader'

export type ErrorFallbackCardProps = ErrorFallbackProps & {
  CustomErrorFallback?: typeof ErrorFallback
  fallbackTitle?: string | ReactNode
}

export const ErrorFallbackCard = ({
  CustomErrorFallback,
  fallbackTitle,
  ...props
}: ErrorFallbackCardProps) => (
  <Card>
    <CardHeader title={fallbackTitle} />
    {CustomErrorFallback ? (
      <CustomErrorFallback {...props} />
    ) : (
      <ErrorFallback {...props} />
    )}
  </Card>
)
